import { render, staticRenderFns } from "./UserRoleSettings.vue?vue&type=template&id=73c48a8a"
import script from "./UserRoleSettings.vue?vue&type=script&lang=js"
export * from "./UserRoleSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports